import { render, staticRenderFns } from "./attachModal.vue?vue&type=template&id=2fbf3554"
import script from "./attachModal.vue?vue&type=script&lang=js"
export * from "./attachModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports